/**
 * Avatar Image Fallback
 *
 * Replaces broken avatar images with the configured default avatar asset.
 */

import { phpAvatarPaths, phpUrl } from "../../../core/php-data-access";
import { AvatarImageFallbackListener } from "./avatar-image-fallback-listener";

function initAvatarImageFallback(): void {
    const urlPath = phpUrl.base.avatar();
    const defaultFilename = String(phpAvatarPaths()?.defaultFilename || "").trim();

    if (!urlPath || !defaultFilename) return;

    const defaultUrl = `${String(urlPath).replace(/\/+$/, "")}/${String(defaultFilename).replace(/^\/+/, "")}`;

    const avatarClassNames = new Set(["avatar-img", "user-avatar", "avatar-preview"]);

    AvatarImageFallbackListener.bindDocumentImageError((event: Event) => {
        const target = event.target;
        if (!(target instanceof HTMLImageElement)) return;

        const isAvatarImg = Array.from(avatarClassNames).some((className) => target.classList.contains(className));
        if (!isAvatarImg) return;

        if (target.dataset.avatarFallbackApplied === "1") return;
        target.dataset.avatarFallbackApplied = "1";

        if (target.src === defaultUrl) return;

        target.src = defaultUrl;
    });
}

export { initAvatarImageFallback };
